import { store } from "@/store";
import { defineStore } from "pinia";
import { getAccessToken, removeToken } from "@/utils/auth";
import { CACHE_KEY, useCache, deleteUserCache } from "@/hooks/web/useCache";
import { getInfo, loginOut } from "@/api/login";
import WebSocketManager from "@/hooks/app/WebSocketManager";

const { wsCache } = useCache();

interface UserVO {
  id: number;
  avatar: string;
  nickname: string;
  username: string;
  deptId: number;
  sex: number;
}

interface UserInfoVO {
  // USER 缓存
  permissions: string[];
  roles: string[];
  isSetUser: boolean;
  user: UserVO;
}

export const useUserStore = defineStore("admin-user", {
  state: (): UserInfoVO => ({
    permissions: [],
    roles: [],
    isSetUser: false,
    user: {
      id: 0,
      avatar: "",
      nickname: "",
      deptId: 0,
      sex: 1,
      username: "",
    },
  }),
  getters: {
    getPermissions(): string[] {
      return this.permissions;
    },
    getRoles(): string[] {
      return this.roles;
    },
    getIsSetUser(): boolean {
      return this.isSetUser;
    },
    getUser(): UserVO {
      return this.user;
    },
  },
  actions: {
    async setUserInfoAction() {
      if (!getAccessToken()) {
        this.resetState();
        return null;
      }
      let userInfo = wsCache.get(CACHE_KEY.USER);
      if (!userInfo) {
        userInfo = await getInfo();
      }
      console.log("userInfo:" + JSON.stringify(userInfo));
      this.permissions = userInfo.permissions;
      this.roles = userInfo.roles;
      this.user = userInfo.user;
      this.isSetUser = true;
      wsCache.set(CACHE_KEY.USER, userInfo);
      //缓存menus
      wsCache.set(CACHE_KEY.ROLE_ROUTERS, userInfo.menus);
    },
    async setUserAvatarAction(avatar: string) {
      const userInfo = wsCache.get(CACHE_KEY.USER);
      // NOTE: 是否需要像`setUserInfoAction`一样判断`userInfo != null`
      this.user.avatar = avatar;
      userInfo.user.avatar = avatar;
      wsCache.set(CACHE_KEY.USER, userInfo);
    },
    async setUserNicknameAction(nickname: string) {
      const userInfo = wsCache.get(CACHE_KEY.USER);
      // NOTE: 是否需要像`setUserInfoAction`一样判断`userInfo != null`
      this.user.nickname = nickname;
      userInfo.user.nickname = nickname;
      wsCache.set(CACHE_KEY.USER, userInfo);
    },
    async setUserSexAction(sex: number) {
      const userInfo = wsCache.get(CACHE_KEY.USER);
      // NOTE: 是否需要像`setUserInfoAction`一样判断`userInfo != null`
      this.user.sex = sex;
      userInfo.user.sex = sex;
      wsCache.set(CACHE_KEY.USER, userInfo);
    },
    async loginOut() {
      await loginOut();
      removeToken();
      deleteUserCache(); // 删除用户缓存
      this.resetState();
      try {
        const ws = WebSocketManager.getInstance();
        ws.closeWebSocket();
      } catch {}
    },
    resetState() {
      this.permissions = [];
      this.roles = [];
      this.isSetUser = false;
      this.user = {
        id: 0,
        avatar: "",
        nickname: "",
        deptId: 0,
        sex: 1, //1男0女
      };
    },
  },
});

export const useUserStoreWithOut = () => {
  return useUserStore(store);
};
